import { spawn } from 'redux-saga/effects';

import { watchGetReleaseNotes } from './getReleaseNotes';
import { watchGetLatestReleaseNote } from './getLatestReleaseNote';

export default function* saga() {
  yield spawn(watchGetReleaseNotes);
  yield spawn(watchGetLatestReleaseNote);
}
